<template>
	<div class="footers">
		<div class="foot">
			<p class="understand">了解我们</p>
			<div v-for="(item,index) in list" :key="index" class="lists" @click="goUrl(item,index)">
				<p>{{item.name}}</p>
			</div>
		</div>
		<div>
			<p class="under">移动端</p>
			<img :src="xcxQrCode" alt="" class="under-1">
			<p class="num">小程序二维码</p>
		</div>
		<div>
			<p class="under">关注我们</p>
			<div class="flex">
				<div style="padding-right: 30px;">
					<img :src="gzQrCode" alt="" class="under-1">
					<p class="num">微信公众号</p>
				</div>
				<div>
					<img :src="wxQrCode" alt="" class="under-1">
					<p class="num">客服微信</p>
				</div>
			</div>
		</div>
		<div>
			<p class="under">联系我们</p>
			<div class="flex margin-8">
				<img src="../assets/head/address.png" alt="" class="under-2">
				<p class="num">地址: {{address}}</p>
			</div>
			<div class="flex margin-8">
				<img src="../assets/head/tel.png" alt="" class="under-2">
				<p class="num">电话: {{mobile}}</p>
			</div>
			<div class="flex margin-24">
				<img src="../assets/head/email.png" alt="" class="under-2">
				<p class="num">邮编: {{zipCode}}</p>
			</div>
			<div style="display: flex;align-items: flex-start;">
				<img src="../assets/head/address.png" alt="" class="under-2">
				<div style="text-align: left;">
					<p class="num num-1"><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #666666; text-decoration: none;">京ICP备17021499号-1</a></p>
				<p class="num num-1">Copyright ©2016-2022 </p>
				<p class="num num-1">教育专家网 All rights reserved.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getInfo
	} from '@/api/api.js';
	export default {
		components: {},
		data() {
			return {
				list: [{
						name: '专家智库',
						url: '/expert/wisdom',
					},
					{
						name: '名校风采',
						url: '/famous/school',
					},
					{
						name: '在线学院',
						url: '/online/school',
					},
					{
						name: '精彩直播',
						url: '/broadcast/index',
					},
					{
						name: '近期活动',
						url: '/activity/index',
					},
					{
						name: '我的收藏',
						url: '/collect/index',
					},
				],
				wxQrCode: '',
				xcxQrCode: '',
				gzQrCode: '',
				zipCode: '',
				address: '',
				mobile: '',
			}
		},
		created() {

		},
		mounted() {
			this.getInfos();
		},
		methods: {
			goUrl(item, index) {
				let token = localStorage.getItem('keyToken');
				if (!token && index == 5) {
					this.$root.loginShow = true;
					return false;
				}
				if (index == 2) {
					return window.open('https://applcqlstrc4234.h5.xiaoeknow.com');
				}
				this.$router.push(item.url)
			},
			getInfos() {
				getInfo().then(res => {
						this.wxQrCode = res.data.wxQrCode;
						this.xcxQrCode = res.data.xcxQrCode;
						this.gzQrCode = res.data.gzQrCode;
						this.zipCode = res.data.zipCode;
						this.address = res.data.address;
						this.mobile = res.data.mobile;




					})
					.catch(error => {});
			},
		}
	}
</script>

<style scoped>
	p {
		cursor: pointer;
	}

	.footers {
		/* height: 312px; */
		margin-top: 70px;
		/* border: 1px solid; */
		background: url(../assets/head/Frame 2703.png) no-repeat;
		background-size: cover;
		padding: 50px 19% 42px 19%;
		display: flex;
		justify-content: space-between;
	}

	.understand {
		font-size: 20px;
		color: #222222;
		padding-bottom: 14px;
		font-family: font4;
	}

	.lists p {
		font-size: 14px;
		font-weight: normal;
		color: #666666;
		height: 20px;
		line-height: 20px;
		margin-top: 6px;
	}

	/* .lists>:first-child p{padding-top:0px;} */
	.under {
		font-size: 20px;
		color: #222222;
		padding-bottom: 20px;
		font-family: font4;
	}

	.under-1 {
		width: 88px;
		height: 88px;
		margin-bottom: 8px;
	}

	.under-2 {
		width: 16px;
		height: 16px;
		padding-right: 5px;
	}

	.num {
		font-size: 14px;
		color: #666666;
		text-align: center;
		font-weight: normal;
	}

	.flex {
		display: flex;
		align-items: center;
	}

	.num-1 {
		text-align: left !important;
		margin-bottom: 5px;
	}

	.margin-8 {
		margin-bottom: 8px;
	}

	.margin-24 {
		margin-bottom: 24px;
	}

	/* 分辨率为1600*1200时 */
	@media (max-width: 1600px) {
		.understand {
			font-size: 19px;
		}

		.under {
			font-size: 19px;
		}

		.lists p {
			font-size: 13px;
		}

		.num {
			font-size: 13px;
		}
	}
</style>